import { createElement } from "react";
import React from "react";
import { useFeliz_React__React_useState_Static_1505 } from "./fable_modules/Feliz.2.7.0/React.fs.js";
import { Page_FromUrl_7F866359 } from "./Pages.js";
import { RouterModule_urlSegments } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { singleton, empty, append, delay, toList } from "./fable_modules/fable-library-js.4.17.0/Seq.js";
import { Disclaimer } from "./Disclaimer.js";
import { Market } from "./Market.js";
import { InsiderTrades } from "./Asset/InsiderTrades.js";
import { ShortOverview } from "./Asset/Short.js";
import { User } from "./User/User.js";
import { PostView } from "./Content/PostView.js";
import { unwrap } from "./fable_modules/fable-library-js.4.17.0/Option.js";
import { PreOpenSummary } from "./PreOpenSummary/PreOpenSummary.js";
import { Search } from "./Search.js";
import { Notifications } from "./Notifications.js";
import { Home } from "./Home.js";
import { Interop_reactApi } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { singleton as singleton_1 } from "./fable_modules/fable-library-js.4.17.0/List.js";
import { Interop_reactApi as Interop_reactApi_1 } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { createObj } from "./fable_modules/fable-library-js.4.17.0/Util.js";
import { createRoot } from "react-dom/client";
import "../assets/style.scss";


export function App() {
    let children;
    const location = useFeliz_React__React_useState_Static_1505(Page_FromUrl_7F866359(RouterModule_urlSegments(window.location.pathname + window.location.search, 2)))[0];
    const props_2 = [["clientId", "768029527019-r3c69btl1u386u0d709ahcl830e4v67k.apps.googleusercontent.com"], ["children", singleton_1((children = toList(delay(() => {
        let matchValue;
        return append((matchValue = location, (matchValue.tag === 0) ? (empty()) : ((matchValue.tag === 6) ? (empty()) : singleton(createElement(Disclaimer, null)))), delay(() => {
            const matchValue_1 = location;
            return (matchValue_1.tag === 1) ? singleton(createElement(Market, {
                ticker: matchValue_1.fields[0],
            })) : ((matchValue_1.tag === 2) ? singleton(createElement(InsiderTrades, null)) : ((matchValue_1.tag === 3) ? singleton(createElement(ShortOverview, null)) : ((matchValue_1.tag === 4) ? singleton(createElement(User, {
                username: matchValue_1.fields[0],
            })) : ((matchValue_1.tag === 5) ? singleton(createElement(PostView, {
                post: unwrap(matchValue_1.fields[0]),
            })) : ((matchValue_1.tag === 8) ? singleton(createElement(PreOpenSummary, {
                date: matchValue_1.fields[0],
            })) : ((matchValue_1.tag === 6) ? singleton(createElement(Search, null)) : ((matchValue_1.tag === 7) ? singleton(createElement(Notifications, null)) : singleton(createElement(Home, null)))))))));
        }));
    })), createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    })))]];
    return Interop_reactApi_1.createElement(GoogleOAuthProvider, createObj(props_2));
}

export const root = createRoot(document.getElementById("aksjeio-app"));

root.render(createElement(App, null));

